import { gql } from "@apollo/client"

export const TOURNAMENT_TYPES_LIST = gql`
  query TournamentTypesList($TournamentTypesInput: TournamentTypesInput!) {
    TournamentTypesList(input: $TournamentTypesInput) {
      status {
        name
        success
        detail
      }
      TournamentTypes {
        id
        name
        private
        status
        storeTournaments
        multiplier
        canBeDouble
      }
    }
  }
`

export const TOURNAMENT_TYPES_LIST_PLAIN = gql`
  query allTournamentTypes {
    allTournamentTypes {
      id
      name
    }
  }
`
